"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _HighlightCard = require("./styles/HighlightCard");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("@site/utils");
var _intents = _interopRequireDefault(require("@ux/intents"));
var _reactMintl = require("@godaddy/react-mintl");
const intents = new _intents.default();
const HighlightCard = ({
  containerClassName,
  largeTextOptions: {
    text: largeText,
    color: textColor,
    maxFontSize = 10.2
  } = {
    text: '',
    color: intents.ux.box.foregroundColor
  },
  smallTextOptions: {
    text: smallText,
    color: smallTextColor
  } = {
    text: '',
    color: intents.ux.box.foregroundColor
  },
  backgroundColor = intents.ux.box.borderColor,
  testId = 'card-container',
  dataCy = 'card-container'
}) => {
  const {
    formatMessage
  } = (0, _reactMintl.useIntl)();
  const fontSize = (0, _utils.adjustFontSize)(formatMessage({
    id: largeText
  }), maxFontSize, 2, 3);
  return /*#__PURE__*/_react.default.createElement(_HighlightCard.CardContainer, {
    className: containerClassName,
    backgroundColor: backgroundColor,
    "data-testid": testId,
    "data-cy": dataCy
  }, /*#__PURE__*/_react.default.createElement(_HighlightCard.LargeText, {
    textColor: textColor,
    "data-testid": "card-large-text",
    fontSize: fontSize
  }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: largeText
  })), /*#__PURE__*/_react.default.createElement(_HighlightCard.SmallText, {
    smallTextColor: smallTextColor,
    "data-testid": "card-small-text"
  }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: smallText
  })));
};
HighlightCard.propTypes = {
  containerClassName: _propTypes.default.string,
  largeTextOptions: _propTypes.default.shape({
    text: _propTypes.default.string.isRequired,
    color: _propTypes.default.string
  }).isRequired,
  smallTextOptions: _propTypes.default.shape({
    text: _propTypes.default.string.isRequired,
    color: _propTypes.default.string
  }).isRequired,
  backgroundColor: _propTypes.default.string,
  testId: _propTypes.default.string,
  dataCy: _propTypes.default.string
};
var _default = exports.default = HighlightCard;